module.exports = __webpack_public_path__ + "static/media/maf-22.25cfc108.png";